module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraLight.2b3c266.eot";